






















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import AnnouncementLink from '@/components/molecules/AnnouncementLink.vue';
import { CaptionCollection } from '@/components/organisms/PortalAnnouncementsPanel.vue';
import {
  UserAnnouncement,
  UpdateUserAnnouncementQueryParam,
} from '@/types/type';

@Component({
  components: { AnnouncementLink },
})
export default class AnnouncementLinks extends Vue {
  @Prop()
  private userAnnouncements!: UserAnnouncement[];

  @Prop()
  private captionCollection!: CaptionCollection;

  private USER_ANNOUNCEMENT_LIMIT: number = 7;

  private get topPageUserAnnouncements(): UserAnnouncement[] {
    return this.userAnnouncements.slice(0, this.USER_ANNOUNCEMENT_LIMIT);
  }

  @Emit('button-link-opened')
  private buttonLinkOpened(
    param: UpdateUserAnnouncementQueryParam
  ): UpdateUserAnnouncementQueryParam {
    return param;
  }
}
